<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <Box theme="box-primary" widget-type="">
        <div slot="content">
          <b-tabs content-class="mt-3">
            <b-tab title="Import số điện thoại mới" active>
              <ImportPhoneNumberSection type="IMPORT_NEW"></ImportPhoneNumberSection>
            </b-tab>
<!--            <b-tab title="Import trạng thái, khách hàng sử dụng" >-->
<!--              <ImportPhoneNumberSection type="IMPORT_STATUS"></ImportPhoneNumberSection>-->
<!--            </b-tab>-->
            <b-tab title="Import phí" >
              <ImportPhoneNumberSection type="IMPORT_FEE"></ImportPhoneNumberSection>
            </b-tab>
            <b-tab title="Import thông tin khóa số" >
              <ImportPhoneNumberSection type="IMPORT_LOCK_INFO"></ImportPhoneNumberSection>
            </b-tab>
          </b-tabs>
        </div>
      </Box>
    </section>
  </div>
</template>

<script>
import Box from '../../../components/Box.vue'
import Utils from '../../../common/utils'
import {mapGetters} from 'vuex'
import ImportPhoneNumberSection from './ImportPhoneNumberSection.vue'

export default {
  name: 'ImportPhoneNumber',
  components: {
    ImportPhoneNumberSection,
    Box,
  },
  data () {
    return {
      company: null,
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  mounted () {
    this.company = Utils.getCompanyByUserInfo(this.userInfo)
  },
  methods: {

  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/phone_number_management/import_phone_number/ImportPhoneNumber.vue